import { Box, Text } from '@factorialco/deprecated-design-system'

import formatCurrency from 'modules/core/lib/formatCurrency'
import i18n from 'modules/core/lib/i18n'

import { salaryFrequency as translateSalaryFrequency } from 'modules/contracts/lib/frequencies'

interface Props {
  salaryFrequency: string
  salaryAmount: number
  employeeLegalEntityId: number
}

const GrossSalary = ({ salaryFrequency, salaryAmount, employeeLegalEntityId }: Props) => {
  const frequency = translateSalaryFrequency(salaryFrequency || '').toLowerCase()
  const currency = formatCurrency(salaryAmount ?? 0, undefined, null, employeeLegalEntityId)

  const salary = currency && frequency ? `${currency} ${frequency}` : currency

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.compensation.base_salary')}
      </Text>
      <Text size="400" weight="medium" color="grey1000">
        {salary}
      </Text>
    </Box>
  )
}

export default GrossSalary
